<template>
  <div class="loading-container" v-show="show">
    <div class="loading"></div>
  </div>
</template>
<script>
export default {
  name: "loading",
  data() {
    return {
      show: false,
    };
  },
};
</script>
<style lang="scss" scoped>
.loading-container {
  position: fixed;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
  top: 0;

  .loading {
    position: absolute;
    width: 100px;
    height: 100px;
    border-radius: 100%;
    border: 5px #ffffff solid;
    border-right-color: #87ceeb;
    animation: loading 1s linear infinite;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
  }
}
@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>